import { loadFrom } from './load';
import { setBasePath } from './utils';
/**
 * Loads the provided UMD-powered pilet.
 * @param meta The pilet's metadata.
 * @param config The configuration for loading the pilet.
 * @param loader The associated loader, either for bundle or single mode.
 */
export function loadUmdPilet(meta, config, loader) {
    setBasePath(meta, meta.link);
    return loadFrom(meta, () => loader(meta, config.crossOrigin));
}
//# sourceMappingURL=umd.js.map